import { render, staticRenderFns } from "./registration-pending.vue?vue&type=template&id=fd3d1fac&scoped=true"
import script from "./registration-pending.vue?vue&type=script&lang=js"
export * from "./registration-pending.vue?vue&type=script&lang=js"
import style0 from "./registration-pending.vue?vue&type=style&index=0&id=fd3d1fac&prod&scoped=true&lang=css"
import style1 from "./registration-pending.vue?vue&type=style&index=1&id=fd3d1fac&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3d1fac",
  null
  
)

export default component.exports